<template lang='pug'>
  v-container
    v-card.d-print-none.mb-5
      v-card-title Existencias
        v-spacer
        v-form(autocomplete='false')
          v-row
    
            v-text-field(v-model='search' append-icon='fa-search' label='Buscar producto' single-line hide-details)
            v-autocomplete.ml-2( v-model='warehouseToGetStock' label='Seleccionar almacén' item-text='name' :items='warehouseRecord' item-value='name' )
            v-switch( v-model="ocultar" label="Sin Stock")
            Crear_producto_dialog( existencia )
 
      v-card-text  
        v-data-table(
          v-model="Requerimientos.lista_de_compras_existencias"
          :headers="itemHeaders" 
          :items="productsRecord(warehouseToGetStock, ocultar)"
          item-key="key"
          show-select 
          
          :footer-props="footerProps" 
          :search='search'
        ) 
        Boton_generar_requerimientos
    v-card.elevation-1
      v-card-title
        span  Requerimientos generados
        v-spacer
        Boton_imprimir.d-print-none(nombre_de_impresion='Documento_de_cotizacion')
      v-card-text#Documento_de_cotizacion
        v-col.d-none.d-print-flex
          h1 Requerimientos generados
          br
          br
          p
            strong Requerido por :
            span {{user}}
        v-data-table( v-model="Cotizaciones.datos.items" :headers='itemHeadersRequered' hide-default-footer  :items='registro_de_requerimientos' item-key='id_requerimiento' show-select  )
        v-col.d-none.d-print-flex
          br
          br
          h3 Atte:
          span {{user}}
</template>

<script>
import { customAuth} from '@/FirebaseConfig'
import { mapGetters, mapActions, mapState } from 'vuex'

import getTotalWarehouse from '../../../store/components/Warehouse'
export default {
  data: ()=>({
    user: customAuth.currentUser.displayName,
    ocultar: false, 
    search: '',
    itemHeaders: [
      { text: 'Código',                 value: 'codigo', sortable: false    },
      { text: 'Nombre del Producto',    value: 'descripcion'},
      { text: 'Presentacion',    value: 'presentacion'},
      { text: 'Cantidad en stock',      value: 'existencia' },
    ],
    	itemHeadersRequered:[
      { text: 'Código',                 value: 'codigo', sortable: false    },
      { text: 'Nombre del Producto',    value: 'descripcion'},
      { text: 'Presentación',    value: 'presentacion'},
      { text: 'Cantidad',      value: 'cantidad' },
      { text: 'Creado por',      value: 'creado_por' },
      { text: 'Fecha ',      value: 'creado_el' },
      { text: 'Estado del requerimiento', value:'estado_de_proceso'}
    ],
    warehouseToGetStock: 'TOTAL',
    footerProps: {
      'items-per-page-options':  [25, 50, -1]
    },
  }),
  props:{
        idCotizacion : String,
    },
  computed: {
    ...mapGetters({
      warehouseRecord: 'Warehouse/record',
      productsRecord: `Product/obtener_existencias`,

    }),
    ...mapState({
      Requerimientos: state=> state.Requerimientos,
     	Cotizaciones: state=>state.Cotizaciones,
      registro_de_requerimientos: state=>state.Requerimientos.record_por_usuario,
      db_activada: state=>state.Customers.db_activada,
      })
  },
  watch:{
    'db_activada'(){
      this.$store.dispatch('Requerimientos/obtener_por_usuario')          
    }
  },
  created(){

    if(this.db_activada){
      this.$store.dispatch('Requerimientos/obtener_por_usuario')          
    }
  },

  methods: {
  
    ...mapActions({
      getTotalWarehouse:  'Warehouse/getTotalWarehouse',
    }),
  },
  components:{
    Boton_generar_requerimientos:()=> import('../components/requerimientos'),
    Boton_imprimir:()=>import ('@/components/boton_imprimir'),
    Crear_producto_dialog: ()=>import('@/views/settings/components/crear_producto_dialog')
  },
}
</script>

